import { FuelParticipation } from '@/generated/codegen';
import { ReportType } from './ReportTypes';

export type MachineForReportRules = {
  fuel_participation?: FuelParticipation | null;
  type: { accepts_usage: boolean };
};

/**
 * Single source of truth for "may this machine take this report type".
 * Returns the user-facing rejection message, or null when the machine is
 * acceptable. Both the full-screen scanner's machine filter (manual
 * selection) and ValidateAccessToMachine (QR scan) derive from this — do not
 * reintroduce per-call-site copies of these rules.
 */
export const machineReportTypeRejection = (
  machine: MachineForReportRules,
  reportType?: ReportType
): string | null => {
  if (reportType === ReportType.DailyReport && !machine.type.accepts_usage) {
    return 'Este tipo de equipo no acepta partes diarios. Por favor, elige otro equipo.';
  } else if (
    reportType === ReportType.StockReport &&
    machine.fuel_participation !== FuelParticipation.CompanyStorage &&
    machine.fuel_participation !== FuelParticipation.Storage
  ) {
    return 'Este equipo no acepta reportes de stock. Por favor, elige otro equipo.';
  } else if (
    reportType === ReportType.FuelReport &&
    machine.fuel_participation === FuelParticipation.None
  ) {
    return 'Este equipo no acepta reportes de despacho. Por favor, elige otro equipo.';
  }
  return null;
};

export const machineAcceptsReportType = (
  machine: MachineForReportRules,
  reportType?: ReportType
): boolean => machineReportTypeRejection(machine, reportType) === null;
